import LoginForm from './LoginForm';
import LoginWrapper from './LoginWrapper';

const Login = ({ currentNetwork, errors, settings }) => (
  <LoginWrapper>
    <LoginForm
      currentNetwork={currentNetwork}
      errors={errors}
      settings={settings}
    />
  </LoginWrapper>
);

export default Login;
